var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBranchBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-branch"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "branch",
    clipPath: "url(#clip-branch)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6246",
    "data-name": "Group 6246",
    transform: "translate(-7242.797 3973.66)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(7246.044 -3969.434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6187",
    "data-name": "Group 6187",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6183",
    "data-name": "Group 6183",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u9577\\u65B9\\u5F62_2687",
    "data-name": "\\u9577\\u65B9\\u5F62 2687",
    d: "M-.493-1H9.892a.507.507,0,0,1,.507.507V14.04a.507.507,0,0,1-.507.507H-.493A.507.507,0,0,1-1,14.04V-.493A.507.507,0,0,1-.493-1ZM9.385.015H.015V13.532h9.37Z",
    transform: "translate(1 1)",
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6182",
    "data-name": "Group 6182",
    transform: "translate(2.794 2.694)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2688",
    "data-name": "Rectangle 2688",
    width: 2.094,
    height: 2.396,
    rx: 1,
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2689",
    "data-name": "Rectangle 2689",
    width: 2.094,
    height: 2.396,
    rx: 1,
    transform: "translate(3.718)",
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2690",
    "data-name": "Rectangle 2690",
    width: 2.094,
    height: 2.396,
    rx: 1,
    transform: "translate(0 3.822)",
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2691",
    "data-name": "Rectangle 2691",
    width: 2.094,
    height: 2.396,
    rx: 1,
    transform: "translate(3.718 3.822)",
    fill: "#377ef3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11172",
    "data-name": "\\u30D1\\u30B9 11172",
    d: "M18.765,48.35h1.826a.746.746,0,0,1,.745.745v3.053a.507.507,0,0,1-.507.507h-2.3a.507.507,0,0,1-.507-.507V49.095A.746.746,0,0,1,18.765,48.35Zm1.556,1.015H19.035v2.276h1.286Z",
    transform: "translate(-13.979 -37.108)",
    fill: "#377ef3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u591A\\u89D2\\u5F62_22",
    "data-name": "\\u591A\\u89D2\\u5F62 22",
    d: "M3.69,5.194h0L1.812,10.684H5.569L3.69,5.194h0m0-1.015a1,1,0,0,1,.96.686l1.878,5.491a1.015,1.015,0,0,1-.96,1.343H1.812a1.015,1.015,0,0,1-.96-1.343L2.73,4.865A1,1,0,0,1,3.69,4.179Z",
    transform: "translate(10.77 2.001)",
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u7DDA_308",
    "data-name": "\\u7DDA 308",
    d: "M.015,4.059H-1V0H.015Z",
    transform: "translate(14.953 11.416)",
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u7DDA_309",
    "data-name": "\\u7DDA 309",
    d: "M7.611.015H0V-1H7.611Z",
    transform: "translate(9.894 15.532)",
    fill: "#377ef3"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2697",
    "data-name": "Rectangle 2697",
    width: 24,
    height: 24,
    transform: "translate(0 0)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBranchBlue);
export default __webpack_public_path__ + "static/media/icon_branch_blue.87c0357872168cda81103a6b4c488f27.svg";
export { ForwardRef as ReactComponent };